import jira from 'src/lib/api/jira';
import { bugsnagNotify } from 'src/lib/bugsnag';
import { errorsToObject } from 'src/lib/error';

import { fatalError, setContext } from './actions';

async function loadContext() {
  const context = await jira.getContext();
  if (context.issueKey) {
    context.issuePdProps = await jira.getIssueProperty(context.issueKey, 'pagerduty');
  }
  return context;
}

const loadSettings = () => jira.getSettings(['v3AuthToken', 'pdApiKey', 'v3Domain', 'v3AddonId']);

const loadSession = () => jira.getJiraSession();

const throwArray = e => { throw e; }; // can not throw array literal directly because of linter rule forced by CRA

const loadAllInitData = async () => {
  const [settings, context, session] = await Promise.all([
    loadSettings().catch(error => ({ error })),
    loadContext().catch(error => ({ error })),
    loadSession().catch(error => ({ error }))
  ]);

  if (session.error) {
    let message = session.error && session.error.message;
    if (typeof message === 'string' && message.includes('status = 0')) {
      throwArray(['Can not connect to Jira', session.error]);
    }
    throwArray(['Can not login to Jira', session.error]);
  }

  if (settings.error && context.error) {
    throwArray(['Can not load Jira settings and context', context.error, settings.error]);
  }

  if (settings.error) {
    throwArray(['Can not load Jira settings', settings.error]);
  }

  if (context.error) {
    throwArray(['Can not load Jira context', context.error]);
  }

  return [settings, context, session];
};

const middleware = store => next => action => {
  const result = next(action);

  switch (action.type) {
    case 'APP_INIT':
      loadAllInitData()
        .then(([{ settings = {} }, context, session]) => {
          try {
            store.dispatch(setContext(context, settings, session));
          } catch (e) {
            if (e && e.stack) {
              bugsnagNotify(e);
            }
            store.dispatch(fatalError(errorsToObject(['Failed to initialize an App', e])));
          }
        })
        .catch(e => {
          if (e && e.stack) {
            bugsnagNotify(e);
          }
          store.dispatch(fatalError(errorsToObject(e)));
        });

      break;
    default:
      break;
  }

  return result;
};

export default middleware;
